/* Reference In Time fixes — updated 13 Sep 2026
   0) On desktop widths the header search bar is relocated to sit
      beside the cart icon (and moved back for mobile widths).
   1) Short product titles on mobile: "Year Brand Series Reference".
      Store titles follow "Year Brand Series [descriptors] <size>mm
      Material(s) Reference", so everything from the size token up to
      (but not including) the final reference token is dropped. Titles
      without a size token (straps, jewelry) are left untouched.
   2) SOLD badge on any product card that lacks one — the Globo
      Smart Product Filter renders cards without the theme's sold
      badge on collection and search pages; the theme's own cards
      already include it.
   3) Sold products demoted to the end of each rendered product grid
      (collection pages, search results, Globo grids). In-stock items
      keep their order; sold items follow, per rendered page.
   4) When Globo replaces the search grid it prints its own product
      count, so the theme's results line is hidden to avoid showing
      two different numbers.
   5) Mobile (≤980px): the sticky header slides away while the
      customer scrolls down and returns on any scroll up (13 Sep
      2026, pairs with rit-fixes.css §7). The theme's own
      collapse-on-scroll runs on desktop only.
   6) SOLD badge on the cards in Globo's header search drawer,
      which lists sold watches priced and unmarked (13 Sep 2026,
      pairs with rit-fixes.css §5).
   7) Globo's sort dropdown anchored so it stays on screen on
      phones — left edge on collection pages, right edge on
      /search (14 Sep 2026, pairs with rit-fixes.css §9).
   Runs on page load, after every Globo render, and on DOM changes.
   Every step is idempotent, so the MutationObserver settles after
   one pass. */
(function () {
  'use strict';

  /* ---------- 0) header search beside the cart (desktop) ---------- */
  var headerMQ = window.matchMedia ? window.matchMedia('(min-width: 981px)') : null;

  function placeHeaderSearch() {
    var identity = document.querySelector('header.theme-header #identity');
    if (!identity) return;
    var ls = identity.querySelector('.large-search');
    var cart = identity.querySelector('.cart--container');
    var logo = identity.querySelector('#logo');
    if (!ls || !cart) return;
    var wide = headerMQ ? headerMQ.matches : false;
    if (wide) {
      if (!cart.contains(ls)) cart.insertBefore(ls, cart.firstChild);
      document.documentElement.classList.add('rit-search-right');
    } else {
      if (cart.contains(ls)) identity.insertBefore(ls, logo || cart);
      document.documentElement.classList.remove('rit-search-right');
    }
  }
  if (headerMQ) {
    if (headerMQ.addEventListener) { headerMQ.addEventListener('change', placeHeaderSearch); }
    else if (headerMQ.addListener) { headerMQ.addListener(placeHeaderSearch); }
  }

  /* ---------- 1) title shortener ---------- */
  var MM_RE = /^\d+(?:\.\d+)?mm$/i;
  var NUM_RE = /^\d+(?:\.\d+)?$/;
  var X_RE = /^[x×]$/i;
  var STOP = { SINGLE: 1, DOUBLE: 1, SEALED: 1, NEW: 1, OLD: 1, STOCK: 1, UNWORN: 1, NOS: 1 };

  function shorten(title) {
    var t = title.trim().split(/\s+/);
    if (t.length < 5) return null;
    var mm = -1;
    for (var i = 2; i < t.length - 1; i++) {
      if (MM_RE.test(t[i])) { mm = i; break; }
    }
    if (mm === -1) return null;
    var cut = mm;
    /* handle dual dimensions like "23 x 30mm" */
    if (cut > 3 && X_RE.test(t[cut - 1]) && NUM_RE.test(t[cut - 2])) cut -= 2;
    var head = [];
    for (var j = 0; j < cut; j++) {
      var w = t[j];
      /* drop all-caps marketing tokens (SINGLE SEALED, NEW OLD STOCK) */
      if (j > 0 && w.length > 2 && w === w.toUpperCase() && STOP[w] === 1) continue;
      head.push(w);
    }
    head.push(t[t.length - 1]);
    var s = head.join(' ');
    return s === title ? null : s;
  }

  function shortenTitles() {
    var nodes = document.querySelectorAll('.product--listing-title:not(.rit-title-processed)');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var full = (el.textContent || '').trim();
      el.classList.add('rit-title-processed');
      var short = shorten(full);
      if (!short) continue;
      el.textContent = '';
      var a = document.createElement('span');
      a.className = 'rit-title-full';
      a.textContent = full;
      var b = document.createElement('span');
      b.className = 'rit-title-short';
      b.textContent = short;
      el.appendChild(a);
      el.appendChild(b);
    }
  }

  /* ---------- shared ---------- */
  function isSold(card) {
    return !!card.querySelector('.price--sold-out, .icn.so, .so.icn');
  }

  /* ---------- 2) SOLD badge ---------- */
  function addBadges() {
    var cards = document.querySelectorAll('.product-index:not(.rit-badge-checked), .collection__page-product:not(.rit-badge-checked)');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      card.classList.add('rit-badge-checked');
      if (card.closest('#predictive-search')) continue;
      if (!card.querySelector('.price--sold-out')) continue;
      if (card.querySelector('.icn.so, .so.icn')) continue;
      var host = card.querySelector('.prod-container') || card;
      var badge = document.createElement('div');
      badge.className = 'so icn rit-sold-badge';
      badge.textContent = 'Sold';
      host.insertBefore(badge, host.firstChild);
    }
  }

  /* ---------- 3) demote sold cards to end of grid ---------- */
  var GRID_SELECTOR = '.collection__page-products, .search_section-grid--wrapper, #gf-products, .gf_products';

  function isCard(el) {
    if (el.nodeType !== 1) return false;
    if (el.classList.contains('product-index') || el.classList.contains('collection__page-product')) return true;
    return !!el.querySelector('.prod-container, .price--listing');
  }

  function demoteSold() {
    var grids = document.querySelectorAll(GRID_SELECTOR);
    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      if (grid.closest('.flickity-enabled, .slick-initialized, #predictive-search')) continue;
      var cards = [];
      for (var i = 0; i < grid.children.length; i++) {
        if (isCard(grid.children[i])) cards.push(grid.children[i]);
      }
      if (cards.length < 2) continue;
      /* only touch the DOM when an in-stock card sits after a sold one */
      var needs = false, seenSold = false;
      for (var c = 0; c < cards.length; c++) {
        if (isSold(cards[c])) { seenSold = true; }
        else if (seenSold) { needs = true; break; }
      }
      if (!needs) continue;
      var frag = document.createDocumentFragment();
      for (var s = 0; s < cards.length; s++) {
        if (isSold(cards[s])) frag.appendChild(cards[s]);
      }
      grid.appendChild(frag);
    }
  }

  /* ---------- 4) avoid double result counts on /search ---------- */
  function tidySearchMeta() {
    var meta = document.querySelector('.rit-search-meta');
    if (meta && meta.style.display !== 'none' && document.getElementById('gf-products')) {
      meta.style.display = 'none';
    }
  }

  /* ---------- 5) mobile: header hides on scroll down, returns on scroll up ---------- */
  /* Toggles .rit-header-hidden on the sticky header section (styled in
     rit-fixes.css §7). Hidden only after the page has scrolled past the
     header itself and the customer keeps moving down; shown again on any
     upward movement of more than a few pixels, or near the top. Not
     hidden while the Globo search drawer or a theme slideout is open.
     To disable, delete this block and rit-fixes.css §7. */
  var mobileMQ = window.matchMedia ? window.matchMedia('(max-width: 980px)') : null;
  var HIDE_AFTER = 12;   /* px of downward travel before hiding */
  var SHOW_AFTER = 6;    /* px of upward travel before showing */
  var stickySection = null;
  var stickyHeight = 0;   /* cached; re-measured on resize, not per scroll */
  var lastY = 0;

  function measureSticky() {
    if (stickySection) stickyHeight = stickySection.offsetHeight || 0;
  }

  function setHeaderHidden(hide) {
    if (!stickySection) return;
    if (hide) { stickySection.classList.add('rit-header-hidden'); }
    else { stickySection.classList.remove('rit-header-hidden'); }
  }

  function drawerOpen() {
    /* Globo's search drawer flags the body; the theme's slideouts are
       popovers, so :popover-open is checked where the browser knows it. */
    if (document.body.classList.contains('gl-search-open')) return true;
    try {
      return !!document.querySelector('.slideout:popover-open, .modal:popover-open');
    } catch (e) {
      return false;
    }
  }

  function onHeaderScroll() {
    /* Cheap enough to run on every scroll event (one class toggle);
       deliberately not deferred to requestAnimationFrame, which some
       browsers throttle and which made the toggle lag behind. */
    if (!stickySection) return;
    var y = window.scrollY || window.pageYOffset || 0;
    if (!(mobileMQ && mobileMQ.matches)) {
      setHeaderHidden(false);
      lastY = y;
      return;
    }
    var dy = y - lastY;
    var h = stickyHeight || stickySection.offsetHeight || 0;
    if (y <= h || drawerOpen()) {
      setHeaderHidden(false);
    } else if (dy > HIDE_AFTER) {
      setHeaderHidden(true);
    } else if (dy < -SHOW_AFTER) {
      setHeaderHidden(false);
    } else {
      return; /* small movement: keep state and the reference point */
    }
    lastY = y;
  }

  function initHeaderScroll() {
    stickySection = document.querySelector('.sticky-header');
    if (!stickySection) return;
    lastY = window.scrollY || window.pageYOffset || 0;
    measureSticky();
    window.addEventListener('resize', measureSticky, { passive: true });
    window.addEventListener('orientationchange', measureSticky, { passive: true });
    window.addEventListener('load', measureSticky);
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    if (mobileMQ) {
      var onChange = function () { if (!mobileMQ.matches) setHeaderHidden(false); };
      if (mobileMQ.addEventListener) { mobileMQ.addEventListener('change', onChange); }
      else if (mobileMQ.addListener) { mobileMQ.addListener(onChange); }
    }
  }

  /* ---------- 6) SOLD badge in Globo's search drawer ---------- */
  /* The header search drawer (#glFilter-search-popup) lists products
     with a price but no availability marker — a search for "batman"
     returns six sold GMT-Masters, all priced, none marked (13 Sep
     2026). Globo's card markup carries only the product handle, so
     availability is read from Shopify's own /products/<handle>.js
     (one small request per product, cached for the page) and a Sold
     badge is added to the card's image, styled in rit-fixes.css §5.
     To disable, delete this block. */
  var availCache = {}; /* handle -> true | false | Promise */

  function drawerBadge(card) {
    if (card.querySelector('.rit-sold-badge')) return;
    card.classList.add('rit-sold');
    var host = card.querySelector('.gl-card-media') || card;
    var badge = document.createElement('div');
    badge.className = 'rit-sold-badge rit-drawer-sold-badge';
    badge.textContent = 'Sold';
    host.insertBefore(badge, host.firstChild);
  }

  function lookupAvailability(handle) {
    var v = availCache[handle];
    if (v === true || v === false) return Promise.resolve(v);
    if (v && v.then) return v;
    v = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var a = j ? !!j.available : true; /* unknown: leave unmarked */
        availCache[handle] = a;
        return a;
      })
      .catch(function () { availCache[handle] = true; return true; });
    availCache[handle] = v;
    return v;
  }

  function markDrawerCards() {
    var cards = document.querySelectorAll('#glFilter-search-popup .gl-product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) continue;
      var handle = m[1];
      if (card.getAttribute('data-rit-handle') === handle) continue; /* already handled */
      card.setAttribute('data-rit-handle', handle);
      card.classList.remove('rit-sold');
      var old = card.querySelector('.rit-sold-badge');
      if (old) old.parentNode.removeChild(old);
      (function (c, h) {
        lookupAvailability(h).then(function (available) {
          if (!available && c.getAttribute('data-rit-handle') === h) drawerBadge(c);
        });
      })(card, handle);
    }
  }

  /* ---------- 7) Globo sort dropdown kept on screen (phones) ---------- */
  /* Globo positions the option list with right: 0 and min-width 220px
     under the sort button. That is right for /search, where the button
     sits at the right of its toolbar, and wrong for collection pages,
     where the button sits at the left edge and the list opened off the
     left of the screen. Per layout: anchor to the button's left edge
     if the list then fits, else to its right edge if that fits, else
     pin it 12px from the screen's left edge. Re-run after every Globo
     render and on resize. */
  var SORT_MIN = 220, SORT_MARGIN = 12;
  function placeSortDropdowns() {
    var lists = document.querySelectorAll('.sort-by .globo-dropdown-custom__options, #globo-dropdown-sort_options');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i]; var wrap = ul.offsetParent || ul.parentElement;
      if (!wrap) continue;
      if (window.innerWidth > 740) { ul.style.removeProperty('left'); ul.style.removeProperty('right'); continue; }
      var vw = window.innerWidth; var r = wrap.getBoundingClientRect();
      var w = Math.min(Math.max(SORT_MIN, r.width), vw - 2 * SORT_MARGIN);
      var left, right;
      if (r.left + w <= vw - SORT_MARGIN) { left = '0px'; right = 'auto'; }
      else if (r.right - w >= SORT_MARGIN) { left = 'auto'; right = '0px'; }
      else { left = Math.round(SORT_MARGIN - r.left) + 'px'; right = 'auto'; }
      ul.style.setProperty('left', left, 'important');
      ul.style.setProperty('right', right, 'important');
    }
  }
  window.addEventListener('resize', placeSortDropdowns, { passive: true });
  window.addEventListener('orientationchange', placeSortDropdowns, { passive: true });
  document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('.sort-by')) placeSortDropdowns(); }, true);

  /* ---------- run pipeline ---------- */
  function run() {
    placeHeaderSearch();
    shortenTitles();
    addBadges();
    demoteSold();
    tidySearchMeta();
    markDrawerCards();
    placeSortDropdowns();
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); initHeaderScroll(); });
  } else {
    run();
    initHeaderScroll();
  }
  window.addEventListener('globoFilterRenderCompleted', schedule);
  function observe() {
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.body) { observe(); } else { document.addEventListener('DOMContentLoaded', observe); }
})();
